/* eslint-disable */
import CustomSelect from "src/shared/CustomSelect";
import MedicalTextBox from "../../MedicalLifeStyle/MedicalTextBox";
import CustomRadioButton from "src/shared/CustomRadioButton";
import Button from "@mui/material/Button";
import Resources from "src/config/Resources";
import { FormikProps } from "formik";
import { useEffect } from "react";

interface Props {
  formik?: FormikProps<any>;
  handleChanges?: any;
  handleBlurs?: any;
  error?: any;
  touch?: any;
  isReview?: boolean;
  setFieldTouch?: any;
  setFieldValue?: any;
  index: number;
  labels: Record<string, any>;
  handleRemoveClick: (index: number) => void;
}

function FamilyMedicalHistoryV2({
  formik,
  handleChanges,
  handleBlurs,
  error,
  touch,
  isReview,
  setFieldTouch,
  setFieldValue,
  index,
  labels,
  handleRemoveClick
}: Props) {
  console.log("marking labels", labels, index);

  useEffect(() => {
    if (formik?.values?.familyMedicalHistory?.[index]?.status === "Alive") {
      formik?.setFieldValue(`familyMedicalHistory[${index}].ageOfDeath`, "");
      formik?.setFieldValue(`familyMedicalHistory[${index}].causeDeath`, "");
    } else if (formik?.values?.familyMedicalHistory?.[index]?.status === "Deceased") {
      formik?.setFieldValue(`familyMedicalHistory[${index}].sufferingAge`, "");
      formik?.setFieldValue(`familyMedicalHistory[${index}].presentStateOfHealth`, "");
    }
  }, [formik?.values?.familyMedicalHistory?.[index]?.status]);

  return (
    <div className="xl:mt-6 lg:mt-6 md:mt-6 sm:mt-4 mt-4 flex xl:flex-row lg:flex-row md:flex-row sm:flex-col flex-col justify-between">
      {labels?.familyPersonName?.label && (
        <div className=" xl:w-[15%] lg:w-[15%] md:w-[15%] sm:w-auto w-auto xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 ">
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium">
            {labels?.familyPersonName?.label}
          </p>
          <MedicalTextBox
            requiredStar
            label={labels?.familyPersonName?.label}
            onChange={handleChanges}
            handleBlur={handleBlurs}
            value={formik?.values?.familyMedicalHistory[index]?.familyPersonName}
            name={`familyMedicalHistory[${index}].familyPersonName`}
            error={error?.familyMedicalHistory?.[index]?.familyPersonName}
            touched={touch?.familyMedicalHistory?.[index]?.familyPersonName}
            disabledField={isReview}
          />
        </div>
      )}
      {labels?.familyRelation?.label && (
        <div className=" xl:w-[15%] lg:w-[15%] md:w-[20%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6">
          <p className="mb-4 text-daintree font-montserrat text-sm font-medium whitespace-nowrap">
            {labels?.familyRelation?.label}
          </p>
          <CustomSelect
            requiredStar
            label={labels?.familyRelation?.label}
            options={labels?.familyRelation?.options}
            onChange={handleChanges}
            setFieldTouched={setFieldTouch}
            value={formik?.values?.familyMedicalHistory?.[index]?.familyRelation}
            name={`familyMedicalHistory[${index}].familyRelation`}
            error={error?.familyMedicalHistory?.[index]?.familyRelation}
            touched={touch?.familyMedicalHistory?.[index]?.familyRelation}
            disabledField={isReview}
          />
        </div>
      )}
      {labels?.status && (
        <div className="xl:w-[20%] lg:w-[20%] md:w-[15%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6">
          {/* <p className="mb-4 text-daintree font-montserrat text-sm font-medium">Status</p> */}
          <CustomRadioButton
            requiredStar
            name={`familyMedicalHistory[${index}].status`}
            label={labels?.status?.label}
            options={labels?.status?.options}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouch}
            error={error?.familyMedicalHistory?.[index]?.status}
            touched={touch?.familyMedicalHistory?.[index]?.status}
            defaultValue={formik?.values?.familyMedicalHistory?.[index]?.status}
            disabled={isReview}
          />
        </div>
      )}
      {formik?.values?.familyMedicalHistory?.[index]?.status === "Deceased" && (
        <div className="xl:w-[27%] lg:w-[27%] md:w-[27%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal whitespace-nowrap">
          {labels?.ageOfDeath?.placeholder && (
            <div className="space-y-2">
              <p className=" text-daintree font-montserrat text-sm font-medium">
                {labels?.ageOfDeath?.placeholder}
              </p>
              <MedicalTextBox
                label={labels?.ageOfDeath?.placeholder}
                requiredStar
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formik?.values?.familyMedicalHistory?.[index]?.ageOfDeath}
                name={`familyMedicalHistory[${index}].ageOfDeath`}
                error={error.familyMedicalHistory?.[index]?.ageOfDeath}
                touched={touch?.familyMedicalHistory?.[index]?.ageOfDeath}
                disabledField={isReview}
              />
            </div>
          )}
          {labels?.causeDeath?.placeholder && (
            <div className="space-y-2">
              <p className="mt-4 text-daintree font-montserrat text-sm font-medium">
                {labels?.causeDeath?.placeholder}
              </p>

              <CustomSelect
                requiredStar
                label={labels?.causeDeath?.placeholder}
                options={labels?.causeDeath?.options}
                onChange={handleChanges}
                setFieldTouched={setFieldTouch}
                value={formik?.values?.familyMedicalHistory?.[index]?.causeDeath}
                name={`familyMedicalHistory[${index}].causeDeath`}
                error={error?.familyMedicalHistory?.[index]?.causeDeath}
                touched={touch?.familyMedicalHistory?.[index]?.causeDeath}
                disabledField={isReview}
              />
            </div>
          )}
        </div>
      )}
      {formik?.values?.familyMedicalHistory?.[index]?.status !== "Deceased" && (
        <div className="xl:w-[27%] lg:w-[27%] md:w-[27%] sm:w-auto w-auto xl:ml-0 lg:ml-0 md:ml-0 sm:ml-10 ml-4 xl:mr-0 lg:mr-0 md:mr-0 sm:mr-10 mr-4 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-6 mt-6 xl:whitespace-nowrap lg:whitespace-nowrap md:whitespace-normal whitespace-nowrap">
          {labels?.sufferingAge?.placeholder && (
            <div className="space-y-2">
              <p className=" text-daintree font-montserrat text-sm font-medium">
                {labels?.sufferingAge?.placeholder}
              </p>
              <MedicalTextBox
                label={labels?.sufferingAge?.placeholder}
                requiredStar
                onChange={handleChanges}
                handleBlur={handleBlurs}
                value={formik?.values?.familyMedicalHistory[index]?.sufferingAge}
                name={`familyMedicalHistory[${index}].sufferingAge`}
                error={error?.familyMedicalHistory?.[index]?.sufferingAge}
                touched={touch?.familyMedicalHistory?.[index]?.sufferingAge}
                disabledField={isReview}
              />
            </div>
          )}
          {labels?.presentStateOfHealth?.placeholder && (
            <div className="space-y-2">
              <p className="mt-4 text-daintree font-montserrat text-sm font-medium">
                {labels?.presentStateOfHealth?.label}
              </p>

              <CustomSelect
                requiredStar
                label={labels?.presentStateOfHealth?.placeholder}
                options={labels?.presentStateOfHealth?.options}
                onChange={handleChanges}
                setFieldTouched={setFieldTouch}
                value={formik?.values?.familyMedicalHistory?.[index]?.presentStateOfHealth}
                name={`familyMedicalHistory[${index}].presentStateOfHealth`}
                error={error?.familyMedicalHistory?.[index]?.presentStateOfHealth}
                touched={touch?.familyMedicalHistory?.[index]?.presentStateOfHealth}
                disabledField={isReview}
              />
            </div>
          )}
        </div>
      )}
      {index !== 0 && (
        <Button
          variant="outlined"
          onClick={() => handleRemoveClick(index)}
          classes={{ root: "!px-0" }}
          className="!text-black !uppercase h-10 !rounded-lg !border-2 !mr-10 w-[5%] !xl:ml-0 !lg:ml-0 !md:ml-0 !sm:ml-0 !ml-4 !xl:mt-0 !lg:mt-0 !md:mt-0 !sm:mt-6 !mt-6 !xl:mb-0 !lg:mb-0 !md:mb-0 !sm:mb-6 !mb-6 "
        >
          <img src={Resources.images.FormDetails.removeIcon} alt="remove" />
        </Button>
      )}
      {index === 0 && <div className="h-10 !mr-10 w-[7%]"></div>}
    </div>
  );
}

FamilyMedicalHistoryV2.defaultProps = {
  formValues: {},
  handleChanges: "",
  handleBlurs: "",
  error: "",
  touch: "",
  isReview: false,
  setFieldTouch: "",
  setFieldValue: "",
  index: 0
};

export default FamilyMedicalHistoryV2;
